/**
 * Counter Service - Default Implementation
 *
 * Provides the default implementation of ICounterService.
 * SPAs can use this directly or create custom implementations.
 */

import { inject, effect } from "../../di";
import type { ICounterState, ICounterService } from "./types";

/**
 * Default counter service implementation.
 * Uses @inject to access state from DiContainer.
 */
export class CounterService implements ICounterService {
  @inject<ICounterState>("counterState")
  counterState!: ICounterState;

  private cleanup?: () => void;

  /**
   * Initialize the service.
   * Sets up reactive effect to watch state changes.
   */
  initialize(): void {
    this.cleanup = effect(() => {});
  }

  /**
   * Dispose the service.
   * Cleans up reactive effects.
   */
  dispose(): void {
    this.cleanup?.();
  }

  increment(): void {
    this.counterState.count.set(this.counterState.count.get() + 1);
    this.counterState.lastUpdated.set(new Date());
  }

  decrement(): void {
    this.counterState.count.set(this.counterState.count.get() - 1);
    this.counterState.lastUpdated.set(new Date());
  }

  reset(): void {
    this.counterState.count.set(0);
    this.counterState.lastUpdated.set(new Date());
  }
}
